import { TopicUser } from './TopicUser';

export class ChannelModel {
  urn!: string;
  meta!: Nullable<
    Partial<{
      title: string;
      type: 'pointer' | 'system' | 'state';
      userURN: string;
      pointerStyle: string;
    }>
  >;
}

export class Channel extends ChannelModel {
  user: Nullable<TopicUser> = null;

  constructor(model: ChannelModel) {
    super();

    Object.assign(this, model);
  }

  get title() {
    return this.meta?.title ?? null;
  }

  get type() {
    return this.meta?.type ?? null;
  }

  get userURN() {
    return this.meta?.userURN ?? null;
  }

  setUser(user: TopicUser) {
    this.user = user;
  }
}
